import React from 'react';
import ReactDOM from 'react-dom/client';
// Two type voices, self-hosted (no external CDN): Fraunces is the "art" voice
// (wordmark + hero), IBM Plex Mono is the "mathematics" voice (coordinates, IDs,
// UI). See App.css for how they're assigned.
import '@fontsource/fraunces/300.css';
import '@fontsource/fraunces/400.css';
import '@fontsource/fraunces/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

// Optional Phase 2 hook: when REACT_APP_AUTH0_AUDIENCE is set, Auth0 issues a
// verifiable JWT access token for that API (so the future backend can validate
// requests). Left unset in dev/local, so login stays identity-only until then.
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
const authorizationParams = {
  redirect_uri: window.location.origin,
  ...(audience ? { audience } : {}),
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={authorizationParams}
      onError={(error) => console.error('[Auth0] initialization error:', error)}
    >
      <App />
    </Auth0Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
